<div class="installation-test">
  <mat-form-field class="test-input onsip-outlined-form" appearance="outline">
    <input
      matInput
      type="text"
      placeholder="{{ 'ONSIP_I18N.YOUR_SITE_URL' | translate }}"
      (change)="resetTest()"
      [formControl]="form"
    />
    @if (form.invalid) {
    <mat-error>{{ getErrorMessage() }}</mat-error>
    }
  </mat-form-field>
  <div class="button-container">
    <button
      mat-flat-button
      color="primary"
      type="submit"
      [disabled]="form.invalid"
      (click)="testUrl()"
    >
      {{ "ONSIP_I18N.TEST_CONNECTION" | translate }}
    </button>
  </div>
</div>
